import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';

export class FormattedMessage extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      parts: `json`,
    };
  }

  get config() {
    return {
      template,
    };
  }
}

export const FormattedMessageEl = defineAndMakeJsxFactory(`mp-formatted-message`, FormattedMessage);
export const FormattedMessageReact = panel2react(`mp-formatted-message`, FormattedMessage);
